import axios from "axios";
import { Action, Thunk, thunk, action } from "easy-peasy";
import { CMS_ITEMS, CMS_PARAMS } from "utils/cmsConstant";
// import { CMS_ITEMS, CMS_PARAMS } from "utils/cmsConstants";

export interface CmsContentModel {
  airlines: any[];
  service: any[];
  fetchAirports: Thunk<CmsContentModel, any>;
  setAirports: Action<CmsContentModel, any>;
  airports: any[];
  modeOfTransport: any;
  setModeOfTransport: Action<CmsContentModel, any>;
  clearAirports: Action<CmsContentModel, any>;
}

const CmsContentStore: CmsContentModel = {
  airlines: [],
  service: [],
  airports: [],
  modeOfTransport: [],

  setModeOfTransport: action((state, mode) => {
    state.modeOfTransport = mode;
  }),

  setAirports: action((state, airportList) => {
    state.airports = airportList;
  }),

  //   setAirlines: action((state, airline) => {
  //     state.airlines = airline;
  //   }),

  //   clearAirlines: action((state) => {
  //     state.airlines = [];
  //   }),

  //   fetchAirline: thunk(async (actions) => {
  //     actions.clearAirlines();
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_CMS_URL}/items/${CMS_ITEMS.AIRLINE}`,
  //         {
  //           params: CMS_PARAMS.airline,
  //           headers: {
  //             Authorization: `bearer ${process.env.REACT_APP_CMS_TOKEN}`,
  //           },
  //         }
  //       );
  //       actions.setAirlines(response.data.data || []);
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   }),

  clearAirports: action((state, value) => {
    state.airports = [];
  }),

  fetchAirports: thunk(async (actions, value, cmsStore) => {
    // console.log("🚀 fetchAirports function is running!", value);
    actions.clearAirports(null);
    const modeOfTransport = cmsStore.getState().modeOfTransport;
    const stationParams = {
      ...CMS_PARAMS.stations,
      "filter[_and][0][type]":
        modeOfTransport && modeOfTransport === "Helicopter" ? null : "airport",
      "filter[_and][1][_or][0][location_code][_icontains]": value,
      "filter[_and][1][_or][1][station_name_en][_icontains]": value,
      "filter[_and][1][_or][2][city_name_en][_icontains]": value,
      "filter[_and][2][status][_eq]": "published",
      sort: "location_code",
      // "limit":30,
    };
    // console.log("Fetching airports...");
    // console.log(
    //   "API URL:",
    //   `${process.env.REACT_APP_CMS_URL}/items/${CMS_ITEMS.STATIONS}`
    // );
    // console.log("Params:", stationParams);
    // console.log("Headers:", {
    //   Authorization: `bearer ${process.env.REACT_APP_CMS_TOKEN}`,
    // });
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_URL}/items/${CMS_ITEMS.STATIONS}`,
        {
          params: stationParams,
          headers: {
            Authorization: `bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );

      const responseData = response.data.data;
      actions.setAirports(responseData || []);
    } catch (e) {
      // console.log(e);
    }
  }),
};

export default CmsContentStore;
